"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _versions = require("../../_utils/versions");

var _tokens = require("../../../tokens");

var _context = require("../../context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: auto;\n  padding: 0;\n  color: ", ";\n  font-size: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getIconColor = function getIconColor(props) {
  if (_tokens.colorPattern.test(props.color)) {
    return props.color;
  }

  var version = (0, _versions.getVersion)(props);
  var requiredColor = props.color;

  if (_tokens.pureColors[version][requiredColor]) {
    return _tokens.pureColors[version][requiredColor];
  }

  if (_tokens.baseColors[requiredColor]) {
    return _tokens.baseColors[requiredColor];
  }

  return 'inherit';
};

var StyledIcon = _styledComponents["default"].span(_templateObject(), function (props) {
  return getIconColor(props);
}, function (props) {
  return parseFloat(props.size);
});

exports.StyledIcon = StyledIcon;

var FontIcon = function FontIcon(props) {
  return _react["default"].createElement(StyledIcon, _extends({}, props, {
    className: props.children
  }), '');
};

FontIcon.propTypes = {
  /** The fontSize applied to the icon */
  size: _propTypes["default"].number,

  /** The color of the component. It supports any color */
  color: _propTypes["default"].string
};
FontIcon.defaultProps = {
  size: 16,
  color: 'inherit'
};
FontIcon.displayName = 'FontIcon';

var _default = (0, _context.withVersion)(FontIcon);

exports["default"] = _default;